export const STORE_SCRIPT_MANAGEMENT = 'scriptManagementUI';
export type STORE_SCRIPT_MANAGEMENT = typeof STORE_SCRIPT_MANAGEMENT;
